/*eslint-disable*/
//用户中心接口设置
import {
  postRequest,
  postRequestParams,
  getRequest,
  postDataParams
} from "@/api/request"; // 导入request中创建的axios实例

const user = {
  // 基本信息
  myInfo: { //获取用户信息
    userMsg: params => { //用户信息
      return postRequest('base/staff/info/getStaff', params)
    },
    //用户资质证书
    getCertificateDetail: detailId => { //用户资质证书详情
      return getRequest('base/staff/info/getCertificate/' + detailId, {})
    },
    saveCertificate: (mode, params) => { //用户资质证书新增-张涛山 | 用户资质证书编辑-张涛山
      return mode == 'add' ?
        postRequest('base/staff/info/addCertificate', params) //用户资质证书新增-张涛山
        :
        postRequest('base/staff/info/updateCertificate', params) //用户资质证书编辑-张涛山
    },
    deleteCertificate: deleteId => { //用户资质证书删除-张涛山
      return getRequest('base/staff/info/deleteCertificate/' + deleteId, {})
    },
    //用户学历证书
    getDiplomaDetail: detailId => { //用户资质证书详情
      return getRequest('base/staff/info/getDiploma/' + detailId, {})
    },
    saveDiploma: (mode, params) => { //用户学历证书新增-张涛山 | 用户学历证书编辑-张涛山
      return mode == 'add' ?
        postRequest('base/staff/info/addDiploma', params) //用户学历证书新增-张涛山
        :
        postRequest('base/staff/info/updateDiploma', params) //用户学历证书编辑-张涛山  
    },
    deleteDiploma: deleteId => { //用户资质证书删除-张涛山
      return getRequest('base/staff/info/deleteDiploma/' + deleteId, {})
    },
  },


  //我的考勤
  myAttendance: {
    daySign: param => { //APP考勤模块-我的考勤-月历详情-张涛山
      return getRequest('app/attendance/attendanceCalendarDetails', param)
    },
    mounthSign: param => { //APP考勤模块-我的考勤-月历异常状态
      return getRequest('app/attendance/attendanceCalendarState', param)
    },

  },
  myfillUpCard: {
    saveFillCard: (mode, params) => {
      return mode == 'add' ?
        postRequest('app/replenish/addTravel', params) // 发起新增补卡 -张涛山
        :
        postRequest('app/replenish/updateReplenish', params) //发起新增补卡编辑-张涛山  
    },
    deleteRecall: (mode, id) => {
      return mode == 'pending' ?
        getRequest('app/replenish/recall/' + id, {}) // 补卡申请撤回张涛山
        :
        getRequest('app/replenish/delete/' + id, {}) //补卡申请删除接口 张涛山
    },

    getReplenish: id => { //获取补卡详情 张涛山
      return getRequest('app/replenish/getReplenish/' + id, {})
    },

  },
  //离职申请
  leavePosition: {
    addLeaveApply: (mode, params) => {
      return mode == 'add' ?
        postRequest('app/applyStaffResign/add', params) //新增用户离职申请接口-肖东
        :
        postRequest('app/applyStaffResign/update', params) //编辑用户离职申请接口-肖东
    },
    delApply: (mode, id) => {
      return mode == 'del' ?
        postRequest('app/applyStaffResign/deleted/' + id, {}) //删除用户离职申请接口-肖东
        :
        postRequest('app/applyStaffResign/recall/' + id, {}) //撤回用户离职申请接口-肖东
    },
    leaveDetail: id => { //离职申请详情接口-肖东
      return getRequest('app/applyStaffResign/details/' + id, {})
    },

  },
  //转正申请
  positionApply: {
    addPositive: (mode, params) => {
      return mode == 'add' ?
        postRequest('/app/applyPositive/add', params) //新增用户转正申请接口-肖东
        :
        postRequest('app/applyPositive/update', params) //编辑用户转正申请接口-肖东
    },
    delApply: (mode, id) => {
      return mode == 'ch' ?
        postRequest('app/applyPositive/applyPositiveRecall/' + id, {}) //撤回用户转正申请接口-肖东
        :
        postRequest('app/applyPositive/deleted/' + id, {}) //删除用户转正申请接口-肖东
    },
    positiveDetail: id => { //转正申请详情接口-肖东
      return getRequest('app/applyPositive/details/' + id, {})
    },

  },
  // 用户转试用申请
  ProbationApply: {
    addProbation: (mode, params) => {
      return mode == 'add' ?
        postRequest('app/applyProbation/add', params) //新增用户转试用申请接口-肖东
        :
        postRequest('app/applyProbation/updateApplyProbation', params) //编辑用户转试用申请接口-肖东
    },
    delApply: (mode, id) => {
      return mode == 'ch' ?
        postRequest('apply/applyProbation/applyProbationRecall/' + id, {}) //撤回用户转试用申请接口-肖东
        :
        postRequest('app/applyProbation/deleted/' + id, {}) //删除用户转试用申请接口-肖东
    },
    probationDetail: id => { //转试用申请详情接口-肖东
      return getRequest('app/applyProbation/details/' + id, {})
    },
  },

  //个人工资条信息
  wageList: (salaryMonth) => {
    return getRequest('app/staffSalarySheet/personalSalary' + '?salaryMonth=' + salaryMonth, {})
  },

  // 记事-列表
  noteList: (pageNum, pageSize, params) => {
    return postRequestParams('app/note/appNoteList/' + pageNum + '/' + pageSize, params)
  },
  //保存记事
  saveNote: (params) => {
    return postRequest('app/note/add', params)
  },

  //记事
  noteBox: {
    noteLike: id => {//记事点赞接口-肖东
      return postRequest('app/note/noteLike/' + id, {})
    },
    noteDetails: id => {//记事详情查询接口-肖东
      return getRequest('app/note/noteDetails/' + id, {})
    },
    noteLikeList: id => {//记事详情查询接口-肖东
      return getRequest('app/note/noteLikeList/' + id, {})
    },
  },
  //获取车库视屏接口
  getVideoUrl: (params) => {
    return getRequest('materialCar/getCarVideoSurveillance', params)
  },

  //招聘信息
  recruit: {
    addRecruit: (mode, params) => {
      return mode == 'add' ?
        postRequest('app/recruiting/add', params) //招聘需求新增接口-陈国贵
        :
        postRequest('app/recruiting/edit', params) //招聘需求编辑接口-陈国贵
    },
    delApply: (mode, id) => {
      return mode == 'hold' ?
        getRequest('app/recruiting/delete/' + id, {}) //根据id删除招聘需求接口-陈国贵
        :
        getRequest('app/recruiting/recall/' + id, {}) //撤回流程接口-陈国贵
    },
    recruitDetail: id => { //招聘需求查看详情接口-陈国贵
      return getRequest('app/recruiting/get/' + id, {})
    },
  },

  //个人中心
  userInfo: {
    dataCentreApply: params => { //数据中心-申请统计接口-肖东
      return getRequest('app/dataCentre/dataCentreApply', params)
    },
    dataCentreAttendance: params => { //数据中心-考勤统计接口-肖东
      return getRequest('app/dataCentre/dataCentreAttendance', params)
    },
    dataCentreAudit: params => { //数据中心-审核统计接口-肖东
      return getRequest('app/dataCentre/dataCentreAudit', params)
    },
    dataCentreMaterial: params => { //数据中心-资产统计接口-肖东
      return getRequest('app/dataCentre/dataCentreMaterial', params)
    },
    dataCentreProject: params => { //数据中心-项目统计接口-肖东
      return getRequest('app/dataCentre/dataCentreProject', params)
    },
    dataCentreReimburse: params => { //数据中心-报销统计接口-肖东 
      return getRequest('app/dataCentre/dataCentreReimburse', params)
    },
  },
  //外派培训申请
  overseasTrain: {
    addApply: (mode, params) => {
      return mode == 'add' ?
        postRequest('app/expatriate/train/addTrain', params) //新增外派培训申请-王愿
        :
        postRequest('app/expatriate/train/updateTrain', params) //编辑外派培训申请-王愿
    },
    delApply: (mode, id) => {
      return mode == 'pending' ?
        getRequest('app/expatriate/train/trainRecall/' + id, {}) //撤回外派培训申请-王愿
        :
        getRequest('app/expatriate/train/deleted/' + id, {}) //删除外派培训申请-王愿
    },
    trainDetail: id => { //外派培训申请详情-王愿 
      return getRequest('app/expatriate/train/getTrain/' + id, {})
    },
  },
  //培训请假申请
  trainLeave: {
    addApply: (mode, params) => {
      return mode == 'add' ?
        postRequest('app/train/leave/addTrainLeave', params) //新增培训请假申请-王愿
        :
        postRequest('app/train/leave/updateTrainLeave', params) //编辑培训请假申请-王愿
    },
    delApply: (mode, id) => {
      return mode == 'pending' ?
        getRequest('app/train/leave/trainRecall/' + id, {}) //撤回培训请假申请-王愿
        :
        getRequest('app/train/leave/delete/' + id, {}) //删除培训请假申请-王愿
    },
    details: id => { //培训请假申请详情-王愿 
      return getRequest('app/train/leave/getTrainLeave/' + id, {})
    },
  },

}
//获取微信登陆授权信息
const Wechat = {
  //获取微信登陆授权信息
  getUserInfo: (params) => {
    return getRequest('share/activity/weChatAuthorization', params) //微信授权接口-肖东
  },
  getShare: (params) => {
    return getRequest('share/activity/activityShare', params) //活动微信分享接口-肖东
  },
}
export default {
  user, Wechat
};